import actions from "./actions";

const initState = {
  announcementResult: [],
  loading: false,
  announcementError: null,
  announcementMessage: null,
  buttonLoading: false,
  deleteButtonLoading: false,
  announcementFormModal: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ANNOUNCEMENT:
      return {
        ...state,
        loading: true,
        announcementError: null,
        announcementMessage: null,
        buttonLoading: false,
        announcementFormModal: false,
      };
    case actions.GET_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        announcementError: null,
        announcementResult: action.announcementResult,
        announcementMessage: null,
        buttonLoading: false,
        announcementFormModal: false,
      };
    case actions.GET_ANNOUNCEMENT_FAILED:
      return {
        ...state,
        loading: false,
        announcementError: action.announcementError,
        announcementMessage: null,
        buttonLoading: false,
        announcementFormModal: false,
      };

    case actions.PREPARE_ANNOUNCEMENT_FORM:
      return {
        ...state,
        loading: false,
        announcementMessage: null,
        announcementError: null,
        buttonLoading: false,
        announcementFormModal: true,
      };

    case actions.ADD_ANNOUNCEMENT:
      return {
        ...state,
        loading: false,
        announcementError: null,
        announcementMessage: null,
        buttonLoading: true,
        announcementFormModal: true,
      };
    case actions.ADD_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        announcementResult: action.announcementResult,
        announcementMessage: action.announcementMessage,
        announcementError: null,
        buttonLoading: false,
        announcementFormModal: false,
      };
    case actions.ADD_ANNOUNCEMENT_FAILED:
      return {
        ...state,
        loading: false,
        announcementMessage: null,
        announcementError: action.announcementError,
        buttonLoading: false,
        announcementFormModal: true,
      };

    case actions.DELETE_ANNOUNCEMENT:
      return {
        ...state,
        loading: false,
        announcementError: null,
        announcementMessage: null,
        deleteButtonLoading: true,
        announcementFormModal: false,
      };
    case actions.DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        announcementMessage: action.announcementMessage,
        announcementResult: action.announcementResult,
        announcementError: null,
        deleteButtonLoading: false,
        announcementFormModal: false,
      };
    case actions.RESET_ANNOUNCEMENT:
      return {
        ...state,
        loading: false,
        announcementMessage: null,
        announcementError: null,
        buttonLoading: false,
        announcementFormModal: false,
      };
    case actions.RESET_ANNOUNCEMENT_MESSAGE:
      return {
        ...state,
        loading: false,
        announcementMessage: null,
        announcementError: null,
        buttonLoading: false,
      };

    default:
      return state;
  }
}
